import { render, staticRenderFns } from "./UpdateSupplierAccount.vue?vue&type=template&id=391c1628&scoped=true&"
import script from "./UpdateSupplierAccount.vue?vue&type=script&lang=js&"
export * from "./UpdateSupplierAccount.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSupplierAccount.vue?vue&type=style&index=0&id=391c1628&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c1628",
  null
  
)

export default component.exports